import React, { createContext, useContext } from "react";
import { InvoiceGenerator } from "../../../../components";
import logo from "../../../../assets/images/tektree-logo-png-1.svg";

// Create context for invoice data
const InvoiceDataContext = createContext();

// Hook to use invoice data
const useInvoiceData = () => {
  const context = useContext(InvoiceDataContext);
  if (!context) {
    throw new Error("useInvoiceData must be used within InvoiceDataProvider");
  }
  return context;
};

const InvoiceList = () => {
  const data = {
    company: {
      name: "TekTree LLC",
      address: "1106 Drummond Plaza, DE 19711",
      contact: "+1 (123) 456-7890",
      email: "accounts@tektreeinc.com",
      website: "www.tektreeinc.com",
      companyLogo: logo,
    },
    invoiceDeta: {
      name: "Shubha Minds LLC",
      address:
        "10520 Chapell Hill road, #156, Morrisville, North California, United States, 27560",
      invoiceNumber: "25100010",
      invoiceDate: "2023-10-10",
      shippedDate: "2023-10-15",
      netTerms: "Net 30",
      dueDate: "2023-10-20",
      invoicedItems: [
        {
          item: "Product A",
          description: "High-quality product A",
          quantity: 2,
          price: 50,
          discount: 0,
        },
        {
          item: "Product B",
          description: "High-quality product B",
          quantity: 5,
          price: 186,
          discount: 10,
        },
        {
          item: "Product C",
          description: "High-quality product C",
          quantity: 16,
          price: 48,
          discount: 2,
        },
        {
          item: "Product D",
          description: "High-quality product D",
          quantity: 55,
          price: 16,
          discount: 0,
        },
        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },
        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },
        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },
        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },
        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },

        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },
        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },
      ],
    },
    additionalInfo: `This Invoice has been Sold & Assigned to Tek Tree LLC Remit payment only to: P.O Box #799, Gloucester, VA - 23061, C/O Chesapeake Bank, Chesapeake Bank`,
  };

  // Components that use context instead of props
  const HeaderMain = ({ currentPage, totalPages } = {}) => {
    const data = useInvoiceData();
    const total = data.invoiceDeta.invoicedItems.reduce(
      (sum, item) => sum + (item.quantity * item.price - (item.discount || 0)),
      0
    );
    return (
      <div className="header-main bg-[#1B4484] text-white flex justify-between items-end px-5 pt-5 ">
        {/* <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold">{data.company.name}</h1>
            <p className="text-sm text-gray-600">{data.company.address}</p>
          </div>
          <div className="text-right">
            <p className="text-sm">Invoice #{data.invoiceDeta.invoiceNumber}</p>
            <p className="text-sm">Date: {data.invoiceDeta.invoiceDate}</p>
          </div>
        </div> */}
        <div className="w-[140px] bg-white rounded-t-xl p-4">
          <img src={data.company.companyLogo} alt={data.company.name} />
        </div>
        <div className="py-2 pr-5 flex flex-col gap-0.5">
          <h6>Total Due</h6>
          <h5>{total.toFixed(2)} USD</h5>
        </div>
      </div>
    );
  };

  const HeaderTwo = ({ currentPage, totalPages } = {}) => {
    const data = useInvoiceData();
    return (
      <div className="header-two bg-gray-50 border-b-gray-200 px-5 py-3">
        {currentPage && totalPages && (
          <div className="flex justify-between items-center">
            <p className="text-xs">
              {/* Page {currentPage} of {totalPages} */}
              {data.invoiceDeta.name}
            </p>
            <p className="text-xs">
              {/* Page {currentPage} of {totalPages} */}
              Invoice #{data.invoiceDeta.invoiceNumber}
            </p>
          </div>
        )}
      </div>
    );
  };

  const ContentTop = () => {
    const data = useInvoiceData();
    return (
      <div className="content-top my-5 grid grid-cols-3 gap-3 p-3 inputShadow rounded-xl">
        <div className="p-5 bg-[#DEEBFF] rounded-xl">
          <h6>Invoice From</h6>
          <h5>{data.company.name}</h5>
          <p className="text-xs">{data.company.address}</p>
          <p className="text-xs">{data.company.email}</p>
          <p className="text-xs">{data.company.website}</p>
        </div>
        <div className="p-5 bg-[#DEEBFF] rounded-xl">
          <h6>Invoice From</h6>
          <h5>{data.invoiceDeta.name}</h5>
          <p className="text-xs">{data.invoiceDeta.address}</p>
        </div>
        <div className="p-5 bg-[#DEEBFF] rounded-xl">
          <h6>Invoice Details:</h6>
          <table className="w-full">
            <tr>
              <td className="text-xs">Invoice Number:</td>
              <td className="text-xs">{data.invoiceDeta.invoiceNumber}</td>
            </tr>
            <tr>
              <td className="text-xs">Invoice Date:</td>
              <td className="text-xs">{data.invoiceDeta.invoiceDate}</td>
            </tr>
            <tr>
              <td className="text-xs">Shipped Date:</td>
              <td className="text-xs">{data.invoiceDeta.shippedDate}</td>
            </tr>
            <tr>
              <td className="text-xs">Net Terms:</td>
              <td className="text-xs">{data.invoiceDeta.netTerms}</td>
            </tr>
            <tr>
              <td className="text-xs">Due Date:</td>
              <td className="text-xs">{data.invoiceDeta.dueDate}</td>
            </tr>
          </table>
        </div>
      </div>
    );
  };

  const ContentBottom = () => {
    const data = useInvoiceData();
    const total = data.invoiceDeta.invoicedItems.reduce(
      (sum, item) => sum + (item.quantity * item.price - (item.discount || 0)),
      0
    );
    return (
      <div className="content-bottom  py-4">
        <div className="flex flex-col gap-5">
          <div className="total flex justify-end">
            <div className=" border border-gray-300">
              <div className="grid grid-cols-2 gap-2 text-xs w-full min-w-80">
                <div className="px-3">Sub Total:</div>
                <div className="text-end px-3"> {total.toFixed(2)} USD</div>
                <div className="px-3">Invoice Total:</div>
                <div className="text-end px-3"> {total.toFixed(2)} USD</div>
                <div className="col-span-2 grid grid-cols-2 gap-2  bg-[#1B4484] text-white px-3">
                  <div>Balance Due:</div>
                  <div className="text-end"> {total.toFixed(2)} USD</div>
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <div className="add-info">
              <div className="w-full max-w-[300px] border border-gray-300 p-4 text-xs">
                <h6>Additional Info:</h6>
                <p>{data.additionalInfo}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const FooterMain = ({ currentPage, totalPages } = {}) => {
    const data = useInvoiceData();
    return (
      <div className="footer-main p-4 bg-[#1B4484] text-white">
        <div className="flex justify-between items-center">
          <div className="text-left">
            <p className="text-sm">Thank you for your business!</p>
            <p className="text-xs">
              {data.company.email} | {data.company.contact}
            </p>
          </div>
        </div>
      </div>
    );
  };

  const FooterTwo = ({ currentPage, totalPages } = {}) => {
    return (
      <div className="footer-two p-2 ">
        <div className="flex justify-between items-center">
          <span className="text-xs text-gray-500">
            Continued on next page... asdadsf{" "}
          </span>
          {currentPage && totalPages && (
            <span className="text-xs font-medium text-gray-600">
              Page {currentPage} of {totalPages}
            </span>
          )}
        </div>
      </div>
    );
  };
  // Table header component for invoice items
  const TableHeader = () => (
    <div className="py-2 px-4 text-xs text-white bg-[#3B66AA]">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-1 text-center">S.No</div>
        <div className="col-span-4">Activity</div>
        <div className="col-span-3 text-center">Service Summary</div>
        <div className="col-span-1 text-center">Qty</div>
        <div className="col-span-1 text-center">Rate</div>
        <div className="col-span-2 text-right">Amount</div>
      </div>
    </div>
  );

  // Custom row renderer for invoice items in tabular format
  const CustomRowRenderer = (item, index) => (
    <div
      key={index}
      className="measure-row py-3 border-b border-slate-200 text-sm box-border "
    >
      <div className="grid grid-cols-12 gap-4 px-4">
        <div className="col-span-1 text-center font-medium text-gray-600">
          {index + 1}
        </div>
        <div className="col-span-4">{item.item}</div>
        <div className="col-span-3 text-cente">{item.description}</div>
        <div className="col-span-1 text-center text-gray-700">
          {/* ${item.price.toFixed(2)} */}
          {item.quantity}
        </div>
        <div className="col-span-1 text-center ">${item.price.toFixed(2)}</div>
        <div className="col-span-2 text-right ">
          ${(item.quantity * item.price - (item.discount || 0)).toFixed(2)}
        </div>
      </div>
    </div>
  );

  return (
    <InvoiceDataContext.Provider value={data}>
      <div className="w-full h-full mx-auto flex justify-center items-start bg-neutral-50 overflow-auto">
        <InvoiceGenerator
          initialPageSize="a4"
          initialLayout="portrait"
          data={data}
          rowRenderer={CustomRowRenderer}
          header={HeaderMain}
          headerTwo={HeaderTwo}
          contentTop={ContentTop}
          contentBottom={ContentBottom}
          footer={FooterMain}
          footerTwo={FooterTwo}
          tableHeader={TableHeader}
          backgroundLogo={logo}
        />
      </div>
    </InvoiceDataContext.Provider>
  );
};

export default InvoiceList;
